/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vang Pham (ptvang@rsupport.com)
 *
 * @description
 *
 * @created at Tue Sep 17 2024
 **/

import { useEffect, useRef } from "react";

const AudioPlayer = ({ srcFile, type }: { srcFile: string; type: string }) => {
	const audioRef = useRef<HTMLAudioElement>(null);

	useEffect(() => {
		return () => {
			if (audioRef.current) {
				audioRef.current.pause();
				audioRef.current.currentTime = 0;
			}
		};
	}, []);

	return (
		<audio ref={audioRef} controls autoPlay>
			<source src={srcFile} type={type} />
			Your browser does not support the audio element.
		</audio>
	);
};

export default AudioPlayer;
